import React from "react";
import { connect } from "react-redux";
import Navbar from "./Navbar";
import "aos/dist/aos.css"; // You can also use <link> for styles
import Aos from "aos";
import Footer from "../component/footer";
import "react-multi-carousel/lib/styles.css";



Aos.init();

function ContactUS(props) {
  return (
    <>
      <div className="mainNav">
        <Navbar  current='Contact us' />
        <div data-aos="zoom-in" data-aos-duration="800" className="front_side">
          <h1 className="front_heading" style={{marginTop:100}}>
          Get in Touch!
          </h1>
 <h2 className="front_heading3"> Whether you have a question about the app, couriers, want to register your business, or anything else, our team will answer all your questions.
 </h2>
         
 {/* <div className="front_buttons">
            <img src={"https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/2021_Facebook_icon.svg/2048px-2021_Facebook_icon.svg.png"} className="play_button1"></img>
            <img src={"https://cdn4.iconfinder.com/data/icons/social-media-icons-the-circle-set/48/twitter_circle-512.png"} className="play_button"></img>

            <img src={"https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Instagram_logo_2022.svg/800px-Instagram_logo_2022.svg.png"} className="play_button"></img>
            <img src={"https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Gmail_icon_%282020%29.svg/1280px-Gmail_icon_%282020%29.svg.png"} className="play_button"></img>

          </div>  */}

        </div>
      </div>
      <img  src={'https://cdn.britannica.com/81/381-050-4632FCC8/Europe-map-features-locator.jpg'} id='video'></img>


      <div style={{backgroundColor: '#16161968'}} className="backVideo"></div>

    <div className="contact55">
      <div className="contact3 py-5 box">
  <div className="row no-gutters">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="card" >
            <img
            
              src="https://www.wrappixel.com/demos/ui-kit/wrapkit/assets/images/contact/2.jpg"
              className="img-fluid"
              style={{borderRadius:5}}
            />
          </div>
        </div>
        <div className="col-lg-6" >
          <div className="contact-box ml-3">
            <h1 className="front_heading5">Quick Contact</h1>
            <form className="mt-4">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group mt-2">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="name"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group mt-2">
                    <input
                      className="form-control"
                      type="email"
                      placeholder="email address"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group mt-2">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="phone"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group mt-2">
                    <textarea
                      className="form-control"
                      rows={3}
                      placeholder="message"
                      defaultValue={""}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="btn btn-danger-gradiant mt-3 text-white border-0 px-3 py-2"
                  >
                    <span> SUBMIT</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="card mt-4 border-0 mb-4">
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <div className="card-body d-flex align-items-center c-detail pl-0">
                  <div className="mr-3 align-self-center">
                    <img src="https://www.wrappixel.com/demos/ui-kit/wrapkit/assets/images/contact/icon1.png" />
                  </div>
                  <div className="">
                    <h6 className="font-weight-medium">Address</h6>
                    <p className="">
                      601 Sherwood Ave.
                      <br /> San Bernandino
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="card-body d-flex align-items-center c-detail">
                  <div className="mr-3 align-self-center">
                    <img src="https://www.wrappixel.com/demos/ui-kit/wrapkit/assets/images/contact/icon2.png" />
                  </div>
                  <div className="">
                    <h6 className="font-weight-medium">Phone</h6>
                    <p className="">
                      251 546 9442
                      <br /> 630 446 8851
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="card-body d-flex align-items-center c-detail">
                  <div className="mr-3 align-self-center">
                    <img src="https://www.wrappixel.com/demos/ui-kit/wrapkit/assets/images/contact/icon3.png" />
                  </div>
                  <div className="">
                    <h6 className="font-weight-medium">Email</h6>
                    <p className="">
                      info@wrappixel.com
                      <br /> 123@wrappixel.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
     

      <Footer />
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    name: state.name,
  };
};

export default connect(mapStateToProps, null)(ContactUS);
